import React, { useEffect, useState } from "react";
import {
  Drawer,
  Form,
  Row,
  Col,
  Button,
  Space,
  Table,
  Typography,
  Divider,
  Input,
  Select
} from "antd";
import { ActivityLogModal } from '../../ActivityLogModal';
import { SearchOutlined } from "@ant-design/icons";
import { ApiCalls } from "../../../shared/ApiCalls";
import { MyInput } from "../../Forms";
import { useDispatch, useSelector } from "react-redux";
import { actionsApi, TableLoader } from "../../../shared";
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const MasterPortalDrawer = ({ visible, callBack, onClose }) => {
  const dispatch = useDispatch();
  const [form2] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visiblelog, setVisibleLog] = useState(false);
  const { androidBoxesLookup, androidBoxesLoading } = useSelector(s => s.masterPortal);
  const { role } = JSON.parse(localStorage.getItem("user"));

  const [oldUrl, setOldUrl] = useState("");
  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendor, setVendor] = useState("all");
  const [selectedBoxes, setSelectedBoxes] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    if (visible) {
      dispatch(actionsApi.getAndroidBoxesLookup({ url: "" }));
      ApiCalls.masterPortal.getVendorList()
        .then(json => {
          if (json.success) {
            setVendorOptions([
              { value: "all", label: t("All Boxes") },
              ...json.data.map(v => ({ value: v.name, label: v.name }))
            ]);
          }
          setVendor("all");
        })
        .catch(() => {
          setVendorOptions([{ value: "all", label: t("All Boxes") }]);
          setVendor("all");
        });
    } else {
      form2.resetFields();
      setOldUrl("");
      setVendor("all");
      setVendorOptions([]);
      setSelectedBoxes([]);
    }
  }, [visible, dispatch, form2, t]);

  const handleUrlSearch = (value) => {
    setOldUrl(value);
    dispatch(actionsApi.getAndroidBoxesLookup({ url: value }));
    setSelectedBoxes([]);
  };

  const handleVendorSearch = () => {
    const payload = { url: oldUrl };
    if (vendor !== "all") payload.name = vendor;
    dispatch(actionsApi.getAndroidBoxesLookup(payload));
    setSelectedBoxes([]);
  };

  const onFinish = async (data) => {
    setLoading(true);
    const payload = {
      url: data.url,
      boxIds: selectedBoxes,
      oldUrl: oldUrl || null,
      vendorID: vendor === "all" ? null : vendor
    };
    const result = await ApiCalls.masterPortal.createMasterPortal(payload);
    setLoading(false);
    if (result) {
      callBack();
      onClose();
    }
  };

  const columns = [
    { title: <Text>{t("Serial #")}</Text>, dataIndex: 'serialNo', key: 'serialNo' },
    { title: <Text>{t("Box Name")}</Text>, dataIndex: 'boxName', key: 'boxName' },
    {
      title: <Text>{t("Mac Address")}</Text>,
      dataIndex: 'macAddress',
      key: 'macAddress',
      render: mac => <Text className='brand-color'>{mac}</Text>
    }
  ];

  const rowSelection = {
    selectedRowKeys: selectedBoxes,
    onChange: keys => setSelectedBoxes(keys)
  };

  return (
    <Drawer
      title={t('Master Portal')}
      onClose={onClose}
      open={visible}
      width={800}
      footer={
        <div className="justify-end">
          <Space>
            <Button onClick={onClose}>{t('Cancel')}</Button>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => form2.submit()}
              loading={loading}
            >
              {t('Update url')}
            </Button>
          </Space>
        </div>
      }
    >
      <Form form={form2} layout="vertical" onFinish={onFinish}>
        <Row gutter={16} align="middle">
          <Col span={12}>
            <Form.Item label={<Text strong>{t("Old Url")}</Text>}>
              <Input.Search
                placeholder={t("e.g. http://rs1.ddns.me:8011")}
                value={oldUrl}
                onChange={e => setOldUrl(e.target.value)}
                onSearch={handleUrlSearch}
                enterButton={<SearchOutlined />}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <MyInput
              name='url'
              label={<Text strong>{t("New Url")}</Text>}
              placeholder={t("e.g. http://rs1.ddns.me:8011")}
              required
              message={t('Please add url')}
              size='large'
            />
          </Col>
          {role === 'masterAdmin' && (
            <Col span={12}>
              <Form.Item label={<Text strong>{t("Vendor")}</Text>}>
                <Input.Group compact>
                  <Select
                    placeholder={t("All Boxes")}
                    options={vendorOptions}
                    value={vendor}
                    onChange={setVendor}
                    size="large"
                    style={{ width: 'calc(100% - 40px)' }}
                  />
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    onClick={handleVendorSearch}
                    size="large"
                  />
                </Input.Group>
              </Form.Item>
            </Col>
          )}
        </Row>

        <Divider />

        <Table
          rowSelection={{ type: "checkbox", ...rowSelection }}
          columns={columns}
          dataSource={androidBoxesLookup}
          className='table-cover'
          pagination={false}
          loading={{ ...TableLoader, spinning: androidBoxesLoading }}
        />
      </Form>

      <ActivityLogModal
        visiblelog={visiblelog}
        onClose={() => setVisibleLog(false)}
      />
    </Drawer>
  );
};

export { MasterPortalDrawer };
